import { useCallback, useEffect, useRef } from "react";

/** Метка своей записи: по ней видно, лежит ли она ещё в стеке. */
const MODAL_HISTORY_ENTRY = { modalHistoryEntry: true };

/**
 * Запись в истории браузера на время, пока модальное окно открыто: «Назад» закрывает окно, а не
 * уводит из статьи. Уходя, запись снимаем за собой — иначе «Назад» в статье надо жать дважды.
 */
const useModalHistoryEntry = (onBack: () => void) => {
	const claimed = useRef(false);
	const back = useRef(onBack);

	useEffect(() => {
		back.current = onBack;
	}, [onBack]);

	const claim = useCallback(() => {
		if (claimed.current) return;
		window.history.pushState(MODAL_HISTORY_ENTRY, "", window.location.href);
		claimed.current = true;
	}, []);

	const release = useCallback(() => {
		if (!claimed.current) return;
		claimed.current = false;
		window.history.back();
	}, []);

	useEffect(() => {
		const onPopState = () => {
			if (!claimed.current) return;
			claimed.current = false;
			back.current();
		};

		window.addEventListener("popstate", onPopState);
		return () => {
			window.removeEventListener("popstate", onPopState);
			release();
		};
	}, [release]);

	return { claim, release };
};

export default useModalHistoryEntry;
